let routes = [{
    name: 'Dashboard',
    icon: 'dashboard',
    path: '/',
    permission: true,
    service:true
},
{
    // external: path is a url the sidebar opens in a new tab, not a route.
    name: 'eAcademy Revised (In progress)',
    icon: 'open_in_new',
    path: 'https://revised.eacademynepal.com',
    external: true,
    permission: true,
    service:true
}
];

export default routes;